import {EventEmitter} from 'eventemitter3'

export const clientEvent = new EventEmitter()

export const clientEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
    DETAIL_CHANGE: 'DETAIL_CHANGE',
    ROLE_CHANGE: 'ROLE_CHANGE',
}

export function getClientEventKey(eventType, clientId) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case clientEventTypes.TABLE_CHANGE:
            return `CLIENT_TABLE_CHANGE`

        case clientEventTypes.DETAIL_CHANGE:
            return `CLIENT_DETAIL_CHANGE`

        case clientEventTypes.ROLE_CHANGE:
            return `CLIENT_ROLE_CHANGE_${clientId}`

        default:
            return ''
    }
}

export function onClientTableChangeListener(
    eventType = clientEventTypes.TABLE_CHANGE,
    data,
) {
    clientEvent.emit(getClientEventKey(eventType), data)
}

export function onClientDetailChangeListener(
    eventType = clientEventTypes.DETAIL_CHANGE,
    data,
) {
    clientEvent.emit(getClientEventKey(eventType), data)
}

export function onClientRolesChangeListener(
    eventType = clientEventTypes.ROLE_CHANGE,
    clientId,
    data,
) {
    clientEvent.emit(getClientEventKey(eventType, clientId), data)
}

export function onClientTableChangeRemoveListener(
    eventType = clientEventTypes.TABLE_CHANGE,
) {
    clientEvent.removeListener(getClientEventKey(eventType))
}

export function onClientDetailChangeRemoveListener(
    eventType = clientEventTypes.DETAIL_CHANGE,
) {
    clientEvent.removeListener(getClientEventKey(eventType))
}

export function onClientRoleChangeRemoveListener(
    eventType = clientEventTypes.ROLE_CHANGE,
    clientId,
) {
    clientEvent.removeListener(getClientEventKey(eventType, clientId))
}
